import { TableStructure } from "../components/TableStructure";

const eNewsLetters = [
  {
    fileStoreId: "619c51c4-d025-4905-872b-0ba86fccce78",
    label: "E-News Letter : January 2019",
  },
  {
    fileStoreId: "b01cbe7d-34ba-4dcd-8a22-0cb08c0bd63d",
    label: "E-News Letter : June 2018",
  },
  {
    fileStoreId: "8fdd2bc9-3f88-4f8a-bf3f-58c20ef213d1",
    label: "E-News Letter : January 2018",
  },
  {
    fileStoreId: "294e315f-aace-4a98-8bf5-cdd7a6463250",
    label: "E-News Letter : December 2017",
  },
  {
    fileStoreId: "dfd5d7d4-3354-4df2-9b11-fbb261559bb9",
    label: "E-News Letter : November 2017",
  },
  {
    fileStoreId: "4b55b493-8fbe-4edd-b5b9-645f735dc3e1",
    label: "E-News Letter : September 2017",
  },
  {
    fileStoreId: "1ce10861-093f-4050-b49d-3b4df599d7d4",
    label: "E-News Letter : August 2017",
  },
  {
    fileStoreId: "2a52b08a-fd44-4650-8414-80fae9fe3786",
    label: "E-News Letter : July 2017",
  },
  {
    fileStoreId: "da99ac85-883f-48ba-9f70-da2315523520",
    label: "E-News Letter : Jun 2017",
  },
  {
    fileStoreId: "3887dd71-e4c7-4f9c-90eb-21139d94432f",
    label: "E-News Letter : May 2017",
  },
  {
    fileStoreId: "3c801f96-3efc-4bb2-a34b-5e6af03513ce",
    label: "E-News Letter : April 2017",
  },
  {
    fileStoreId: "862d8ac2-08e1-42cb-a25e-1efe88921506",
    label: "E-News Letter : March 2017",
  },
  {
    fileStoreId: "ec306596-30bb-4e0b-bf4b-53ab725d1bee",
    label: "E-News Letter : February 2017",
  },
  {
    fileStoreId: "a29ee00b-ad33-41dd-86ff-006e2e44a595",
    label: "E-News Letter : January 2017",
  },
  {
    fileStoreId: "4a7f9571-a895-40b7-93a7-c9559b743d46",
    label: "E-News Letter : December 2016",
  },
  {
    fileStoreId: "81a08449-73db-41cd-9f7c-7f3e6f9dcf97",
    label: "E-News Letter : November 2016",
  },
  {
    fileStoreId: "236ecbe4-45ef-4f6b-b8a7-1eae1b9c81b3",
    label: "E-News Letter : October 2016",
  },
  {
    fileStoreId: "6d802112-1749-48e2-aeb5-1858dac203fe",
    label: "E-News Letter : September 2016",
  },
  {
    fileStoreId: "34c879bb-6de3-483d-9e5c-35d4d561aa23",
    label: "E-News Letter : August 2016",
  },
  {
    fileStoreId: "53dd0ca8-a67d-4f6c-962b-eb041d600e28",
    label: "E-News Letter : July 2016",
  },
  {
    fileStoreId: "bb281c26-0e79-4a34-ae45-873f4f3fa9a3",
    label: "E-News Letter : March 2016",
  },
  {
    fileStoreId: "774c9a89-2328-41ac-ae0e-655f1c7ec2b4",
    label: "E-News Letter : February 2016",
  },
];

const E_News_Letter = () => (
  <TableStructure
    heading={"KMC E-News Letter Publications"}
    list={eNewsLetters}
  />
);

export default E_News_Letter;
